var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var CannotReadNextValueError = /** @class */ (function (_super) {
    __extends(CannotReadNextValueError, _super);
    function CannotReadNextValueError(delimiter, byteScanned) {
        var _this = _super.call(this, "Cannot find end of the row ".concat(JSON.stringify(delimiter), ", or quoted value is too long. Scanned ").concat((byteScanned / 1024).toFixed(2), "KB, but then stopped.")) || this;
        _this.delimiter = delimiter;
        _this.byteScanned = byteScanned;
        return _this;
    }
    return CannotReadNextValueError;
}(Error));
export { CannotReadNextValueError };
//# sourceMappingURL=CannotReadNextValueError.js.map